import { Plus, Settings, UserPlus } from "lucide-react";
import * as React from "react";

import { DropdownMenuGroup, DropdownMenuItem } from "@/components/ui/dropdown";

interface QuickActionsProps {
  canInvite: boolean;
  activeOrganizationId?: number;
  onInviteClick: () => void;
  onManageOrganizations: () => void;
  onManageWorkspaces: () => void;
}

export const QuickActions: React.FC<QuickActionsProps> = ({
  canInvite,
  onInviteClick,
  onManageOrganizations,
  onManageWorkspaces,
}) => (
  <DropdownMenuGroup>
    {canInvite && (
      <DropdownMenuItem
        onClick={onInviteClick}
        className="mx-1 gap-2 rounded-md px-2 py-1.5 text-gray-600"
      >
        <UserPlus className="size-3.5" />
        <span className="text-sm">Invite to workspace</span>
      </DropdownMenuItem>
    )}
    <DropdownMenuItem
      onClick={onManageOrganizations}
      className="mx-1 gap-2 rounded-md px-2 py-1.5 text-gray-600"
    >
      <Settings className="size-3.5" />
      <span className="text-sm">Manage organizations</span>
    </DropdownMenuItem>
    <DropdownMenuItem
      onClick={onManageWorkspaces}
      className="mx-1 gap-2 rounded-md px-2 py-1.5 text-gray-600"
    >
      <Plus className="size-3.5" />
      <span className="text-sm">Create workspace</span>
    </DropdownMenuItem>
  </DropdownMenuGroup>
);
